// @flow
import styles from './JobMeta.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ScreenReaderOnly, Strong, Text, Hidden } from 'seek-style-guide/react';
import { getFormattedDate } from 'src/modules/get-formatted-date';

type Props = {
  job: ChaliceJobDetail
};

function ClassificationMeta({
  job: { classification, subClassification }
}: Props) {
  if (!classification) {
    return null;
  }

  const scDescription = subClassification ? (
    <span className={styles.metaRefinement}>
      <Hidden desktop>{', '}</Hidden>
      {subClassification.description}
    </span>
  ) : null;

  // Yes, you can wrap a dl dt in a div.
  // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dl#Wrapping_name-value_groups_in_<div>_elements
  return (
    <div>
      <dt>
        <ScreenReaderOnly>Classification</ScreenReaderOnly>
      </dt>
      <dd>
        <Text small>
          <Strong>{classification.description}</Strong>
          {scDescription}
        </Text>
      </dd>
    </div>
  );
}

export default class JobMeta extends Component<Props> {
  static propTypes = {
    job: PropTypes.object
  };

  render() {
    const { listingDate, locationHierarchy, salary, workType } = this.props.job;
    const { city: location, area } = locationHierarchy || {};

    return (
      <section role="region" aria-labelledby="jobInfoHeader">
        <ScreenReaderOnly>
          <h1 id="jobInfoHeader">Job Information</h1>
        </ScreenReaderOnly>
        <dl>
          <dt>
            <ScreenReaderOnly>Job Listing Date</ScreenReaderOnly>
          </dt>
          <dd data-automation="job-detail-date">
            <Text small strong>
              {getFormattedDate(listingDate)}
            </Text>
          </dd>
          <dt>
            <ScreenReaderOnly>Location</ScreenReaderOnly>
          </dt>
          <dd>
            <Text small>
              <Strong>{location}</Strong>
              {area ? (
                <span className={styles.metaRefinement}>
                  <Hidden desktop>{', '}</Hidden>
                  {area}
                </span>
              ) : null}
            </Text>
          </dd>
          {salary ? (
            <div>
              <dt>
                <ScreenReaderOnly>Salary</ScreenReaderOnly>
              </dt>
              <dd>
                <Text small strong>
                  {salary}
                </Text>
              </dd>
            </div>
          ) : null}
          <dt>
            <ScreenReaderOnly>Work Type</ScreenReaderOnly>
          </dt>
          <dd data-automation="job-detail-work-type">
            <Text small strong>
              {workType}
            </Text>
          </dd>
          <ClassificationMeta job={this.props.job} />
        </dl>
      </section>
    );
  }
}
